import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MdbTablePaginationComponent, MdbTableDirective, ModalDirective } from 'angular-bootstrap-md';
import { eventNames } from 'cluster';
import { truncate } from 'fs';
import { AlertService } from 'ngx-alerts';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { DiasModule } from '../../modelo/dias/dias.module';
import { HojaModule } from '../../modelo/hoja/hoja.module';
import { PeriodoModule } from '../../modelo/hoja/periodo';
import { LoginService } from '../../servicios/login.service';
import { ProducionService } from '../../servicios/producion.service';
import * as XLSX from 'xlsx';
import { EmailModule } from '../../modelo/hoja/email';
@Component({
  selector: 'app-hoja-locales',
  templateUrl: './hoja-locales.component.html',
  styleUrls: ['./hoja-locales.component.css']
})
export class HojaLocalesComponent implements OnInit {

  lunes:boolean;
  martes:boolean;
  miercoles:boolean;
  jueves:boolean;
  searchText: string = '';
  viernes:boolean;
  ordenar:boolean;
  sabado:boolean;
  domingo:boolean;
  fechaHoja:string;
  lunescolor:string;
  martescolor:string;
  miercolescolor:string;
  juevescolor:string;
  viernescolor:string;
  sabadocolor:string;
  domingocolor:string;
  periodo:string;
  listaPeriodo:PeriodoModule[];
  listaEnviar:EmailModule[];
  listaProducion: HojaModule[];
  listaProducionDevolucion: HojaModule[];
  listaProducionConsulta: HojaModule[];
  listaProducionLunes: HojaModule[];
  listaProducionDomingo: HojaModule[];
  listaCategorias: HojaModule[];
  dias:DiasModule= new DiasModule();
  ordenarConsulta:boolean;
  ampmdomingoLunes:boolean
  dia:string;
  anio_periodo:string;
  collunes:boolean;
  devlunes:boolean;
  colmartes:boolean;
  devmartes:boolean;
  devmiercoles:boolean;
  devjueves:boolean;
  devviernes:boolean;
  devsabado:boolean;
  devdomingo:boolean;
  devdomingoLunes:boolean;
  fileName= 'HojaProduccion.xlsx';
  usuario:string;
  id_pais:string;
  local:string;
  email:EmailModule;
  colmiercoles:boolean;
  parametro:string;
  coljueves:boolean;
  colvienes:boolean;
  colsabado:boolean;
  coldomingo:boolean;
  perdio:number;
  limpiar:boolean;
  totalSugerido:number;
  totalAmR1:number;
  totalPmR1:number;
  totalAm1:number;
  totalPm1:number;
  totalDev1:number;
  totalAmR2:number;
  totalPmR2:number;
  totalAm2:number;
  totalPm2:number;
  totalDev2:number;
  totalAmR3:number;
  totalPmR3:number;
  totalAm3:number;
  totalPm3:number;
  totalDev3:number;

  totalAmR4:number;
  totalPmR4:number;
  totalAm4:number;
  totalPm4:number;
  totalDev4:number;


  totalAmR5:number;
  totalPmR5:number;
  totalAm5:number;
  totalPm5:number;
  totalDev5:number;


  totalAmR6:number;
  totalPmR6:number;
  totalAm6:number;
  totalPm6:number;
  totalDev6:number;


  totalAmR7:number;
  totalPmR7:number;
  totalAm7:number;
  totalPm7:number;
  totalDev7:number;

  totalDev:number;
  totalLocal:number;
  totalPorcentaje:number;
  totalColor:string;
  amlunes:boolean;
  ammartes:boolean;

  ammiercoles:boolean;
 amjueves:boolean;
  amviernes:boolean;
  amsabado:boolean;
  amdomingo:boolean;
  ordedar:boolean;
  searchText1:string;

  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  @ViewChild(MdbTableDirective) mdbTableDev: MdbTableDirective;
  @ViewChild(MdbTableDirective) tableElBus: MdbTableDirective;


  

  @ViewChild('lgModal') public lgModal: ModalDirective;
  previous: any = [];
  constructor(    private alertService: AlertService,private apiHoja: ProducionService,private datepipe: DatePipe,) { }

  

  ngOnInit(): void {
    this.id_pais=localStorage.getItem("id_pais");
    this.listaProducion=[];
    this.buscarProduccionesPorLocal();
    this.buscarPeriodos();
    this.buscarDias();
    this.usuario=localStorage.getItem("nombre");
    this.local=localStorage.getItem("nombreLocal");
    this.listaProducionConsulta=[];
    
  }


  exportexcel(): void
  {
    /* pass here the table id */
    let element = document.getElementById('hojaProduccion');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    console.log(element);
   var workbook=XLSX.writeFile(wb,'./assets/result.xlsx');
   
   const newData= XLSX.read(wb);
   console.log(newData);
    
  }



  enviarEmail(): void
  {
    /* pass here the table id */
    var element = document.getElementById('tablaDevolucion').outerHTML;
    this.listaEnviar=[];
    this.email= new EmailModule();
    this.email.email=localStorage.getItem('meail').toString();
    this.email.html=element.toString();
    this.listaEnviar.push(this.email);
    this.apiHoja.enviarEmail(this.listaEnviar,localStorage.getItem("nombreLocal"))
    .subscribe((
      data: string[]) => {
        this.alertService.info('Se envio el email  con exito..')
    },
    err =>  this.alertService.warning('Correo no Enviado...')
    );

    
  }

  onCheckLimpiar(e) {
    this.searchText="";
    e.target.checked=false; 
   this.searchItems();

  }


  onCheckboxOrdenar(e) {

    //if (e.target.checked) {
      this.searchText=null;
      this.searchItems();
        this.listaProducion.sort((a, b) => a.numeral - b.numeral);
        e.target.checked=false;  
   // }

  }


  onCheckboxOrdenarConsulta(e) {

        this.listaProducionConsulta.sort((a, b) => a.numeral - b.numeral);
        e.target.checked=false;
   
  }

  buscar(){
    this.listaPeriodo.forEach(element => {
      if (element.semana.toString()==this.periodo){
          this.fechaHoja=element.fecha;
          this.anio_periodo=this.fechaHoja.substring(0,4)+"-"+this.periodo
      }
    });
    this.totalDev=0;  
    this.totalPorcentaje=0;
    this.totalLocal=0;
    this.totalSugerido=0;
    this.totalAm1=0;
    this.totalPm1=0;
    this.totalDev1=0;
    this.totalAmR1=0;
    this.totalPmR1=0;

    this.totalAm2=0;
    this.totalPm2=0;
    this.totalDev2=0;
    this.totalAmR2=0;
    this.totalPmR2=0;
   
   
    this.totalAm3=0;
    this.totalPm3=0;
    this.totalDev3=0;
    this.totalAmR3=0;
    this.totalPmR3=0;
   


    this.totalAm4=0;
    this.totalPm4=0;
    this.totalDev4=0;
    this.totalAmR4=0;
    this.totalPmR4=0;
   


    this.totalAm5=0;
    this.totalPm5=0;
    this.totalDev5=0;
    this.totalAmR5=0;
    this.totalPmR5=0;
   


    this.totalAm6=0;
    this.totalPm6=0;
    this.totalDev6=0;
    this.totalAmR6=0;
    this.totalPmR6=0;
   


    this.totalAm7=0;
    this.totalPm7=0;
    this.totalDev7=0;
    this.totalAmR7=0;
    this.totalPmR7=0;
   
   
    this.apiHoja.listarProduccionPorLocalxPeriodo(localStorage.getItem("local"), this.anio_periodo,this.id_pais)
     .subscribe((
       data: HojaModule[]) => {
         this.listaProducionConsulta = data;

         this.listaProducionConsulta.forEach(element => {
          this.totalAm1=this.totalAm1+ Number.parseFloat(this.validarNumeros(element.am1));
          this.totalPm1=this.totalPm1+ Number.parseFloat(this.validarNumeros(element.pm1));
          this.totalDev1=this.totalDev1+ Number.parseFloat(this.validarNumeros(element.dev1));
          this.totalAmR1=this.totalAmR1+ Number.parseFloat(this.validarNumeros(element.amval1));
          this.totalPmR1=this.totalPmR1+ Number.parseFloat(this.validarNumeros(element.valpm1));
       

          this.totalAm2=this.totalAm2+ Number.parseFloat(this.validarNumeros(element.am2));
          this.totalPm2=this.totalPm2+ Number.parseFloat(this.validarNumeros(element.pm2));
          this.totalDev2=this.totalDev2+ Number.parseFloat(this.validarNumeros(element.dev2));
          this.totalAmR2=this.totalAmR2+ Number.parseFloat(this.validarNumeros(element.valam2));
          this.totalPmR2=this.totalPmR2+ Number.parseFloat(this.validarNumeros(element.valpm2));
       


          this.totalAm3=this.totalAm3+ Number.parseFloat(this.validarNumeros(element.am3));
          this.totalPm3=this.totalPm3+ Number.parseFloat(this.validarNumeros(element.pm3));
          this.totalDev3=this.totalDev3+ Number.parseFloat(this.validarNumeros(element.dev3));
          this.totalAmR3=this.totalAmR3+ Number.parseFloat(this.validarNumeros(element.amval3));
          this.totalPmR3=this.totalPmR3+ Number.parseFloat(this.validarNumeros(element.valpm3));
       


          this.totalAm4=this.totalAm4+ Number.parseFloat(this.validarNumeros(element.am4));
          this.totalPm4=this.totalPm4+ Number.parseFloat(this.validarNumeros(element.pm4));
          this.totalDev4=this.totalDev4+ Number.parseFloat(this.validarNumeros(element.dev4));
          this.totalAmR4=this.totalAmR4+ Number.parseFloat(this.validarNumeros(element.amval4));
          this.totalPmR4=this.totalPmR4+ Number.parseFloat(this.validarNumeros(element.valpm4));
       



          this.totalAm5=this.totalAm5+ Number.parseFloat(this.validarNumeros(element.am5));
          this.totalPm5=this.totalPm5+ Number.parseFloat(this.validarNumeros(element.pm5));
          this.totalDev5=this.totalDev5+ Number.parseFloat(this.validarNumeros(element.dev5));
          this.totalAmR5=this.totalAmR5+ Number.parseFloat(this.validarNumeros(element.amval5));
          this.totalPmR5=this.totalPmR5+ Number.parseFloat(this.validarNumeros(element.valpm5));
       

          this.totalAm6=this.totalAm6+ Number.parseFloat(this.validarNumeros(element.am6));
          this.totalPm6=this.totalPm6+ Number.parseFloat(this.validarNumeros(element.pm6));
          this.totalDev6=this.totalDev6+ Number.parseFloat(this.validarNumeros(element.dev6));
          this.totalAmR6=this.totalAmR6+ Number.parseFloat(this.validarNumeros(element.amval6));
          this.totalPmR6=this.totalPmR6+ Number.parseFloat(this.validarNumeros(element.valpm6));
      
          

          this.totalAm7=this.totalAm7+ Number.parseFloat(this.validarNumeros(element.am7));
          this.totalPm7=this.totalPm7+ Number.parseFloat(this.validarNumeros(element.pm7));
          this.totalDev7=this.totalDev7+ Number.parseFloat(this.validarNumeros(element.dev7));
          this.totalAmR7=this.totalAmR7+ Number.parseFloat(this.validarNumeros(element.amval7));
          this.totalPmR7=this.totalPmR7+ Number.parseFloat(this.validarNumeros(element.valpm7));


        });

         this.listaProducionConsulta.forEach(element => {
          element.sugerido=
          Number.parseFloat(this.validarNumeros(element.am1))+
         Number.parseFloat(this.validarNumeros(element.pm1))+
         Number.parseFloat(this.validarNumeros(element.am2))+
         Number.parseFloat(this.validarNumeros(element.pm2))+
         Number.parseFloat(this.validarNumeros(element.am3))+
         Number.parseFloat(this.validarNumeros(element.pm3))+
         Number.parseFloat(this.validarNumeros(element.am4))+
         Number.parseFloat(this.validarNumeros(element.pm4))+
         Number.parseFloat(this.validarNumeros(element.am5))+
         Number.parseFloat(this.validarNumeros(element.pm5))+
         Number.parseFloat(this.validarNumeros(element.am6))+
         Number.parseFloat(this.validarNumeros(element.pm6))+
         Number.parseFloat(this.validarNumeros(element.am7))+
         Number.parseFloat(this.validarNumeros(element.pm7));
       

         element.local=(
         Number.parseFloat(this.validarNumeros(element.amval1))+
        Number.parseFloat(this.validarNumeros(element.valpm1))+
        Number.parseFloat(this.validarNumeros(element.valam2))+
        Number.parseFloat(this.validarNumeros(element.valpm2))+
        Number.parseFloat(this.validarNumeros(element.amval3))+
        Number.parseFloat(this.validarNumeros(element.valpm3))+
        Number.parseFloat(this.validarNumeros(element.amval4))+
        Number.parseFloat(this.validarNumeros(element.valpm4))+
        Number.parseFloat(this.validarNumeros(element.amval5))+
        Number.parseFloat(this.validarNumeros(element.valpm5))+
        Number.parseFloat(this.validarNumeros(element.amval6))+
        Number.parseFloat(this.validarNumeros(element.valpm6))+
        Number.parseFloat(this.validarNumeros(element.amval7))+
        Number.parseFloat(this.validarNumeros(element.valpm7))
       
        );
       element.devolucion=(
        Number.parseFloat(this.validarNumeros(element.dev1))+
        Number.parseFloat(this.validarNumeros(element.dev2))+
        Number.parseFloat(this.validarNumeros(element.dev3))+
        Number.parseFloat(this.validarNumeros(element.dev4))+
        Number.parseFloat(this.validarNumeros(element.dev5))+
        Number.parseFloat(this.validarNumeros(element.dev6))+
        Number.parseFloat(this.validarNumeros(element.dev7))
        );

      this.totalLocal=this.totalLocal+element.local;
      this.totalDev=this.totalDev+element.devolucion;
      this.totalSugerido=this.totalSugerido+element.sugerido;

        if (element.local>0){
          element.porcentaje=(element.devolucion/element.local)*100;
        }else{
          element.porcentaje=0;

        }

        let valor=element.porcentaje;
        if (valor>=0 && valor<10){
          element.colorPorcentaje="white"
        }
        if (valor>=10 && valor<15){
         element.colorPorcentaje="yellow"
       }
       if (valor>=15 && valor<30){
         element.colorPorcentaje="orange"
       }
       if (valor>=30){
         element.colorPorcentaje="red"
       }

        });
 
        this.listaProducionConsulta.forEach(element => {
          if (element.sugerido>element.local){
            element.color="orange";
          }else{
            element.color=" ";
          }
          
        });
        if (this.totalLocal>0){
        this.totalPorcentaje=(this.totalDev/this.totalLocal)*100;
        }else{
          this.totalPorcentaje=0;
        }

        let valor= this.totalPorcentaje;
        if (valor>=0 && valor<10){
         this.totalColor="white"
        }
        if (valor>=10 && valor<15){
          this.totalColor="yellow"
       }
       if (valor>=15 && valor<30){
        this.totalColor="orange"
       }
       if (valor>=30){
        this.totalColor="red"
       }


       this.listaProducionConsulta.forEach(element => {
        
        //Lunes
        if (element.dev1 == 0 ){
          element.dev1=0;
        }
          if (element.amval1 == 0 ){
            element.amval1=0;
          }
          
          if (element.valpm1 == 0 ){
            element.valpm1=0;
          }


           //Martes
        if (element.dev2 == 0 ){
          element.dev2=0;
        }
          if (element.valam2 == 0 ){
            element.valam2=0;
          }
          
          if (element.valpm2 == 0 ){
            element.valpm2=0;
          }

            //Miercoles
        if (element.dev3 == 0 ){
          element.dev3=0;
        }
          if (element.amval3 == 0 ){
            element.amval3=0;
          }
          
          if (element.valpm3 == 0 ){
            element.valpm3=0;
          }

              //Jueves
        if (element.dev4 == 0 ){
          element.dev4=0;
        }
          if (element.amval4 == 0 ){
            element.amval4=0;
          }
          
          if (element.valpm4 == 0 ){
            element.valpm4=0;
          }

              //Viernes
        if (element.dev5 == 0 ){
          element.dev5=0;
        }
          if (element.amval5 == 0 ){
            element.amval5=0;
          }
          
          if (element.valpm5 == 0 ){
            element.valpm5=0;
          }

               //Sabado
        if (element.dev6 == 0 ){
          element.dev6=0;
        }
          if (element.amval6 == 0 ){
            element.amval6=0;
          }
          
          if (element.valpm6 == 0 ){
            element.valpm6=0;
          }


            //Domingo
        if (element.dev7 == 0 ){
          element.dev7=0;
        }
          if (element.amval7 == 0 ){
            element.amval7=0;
          }
          
          if (element.valpm7 == 0 ){
            element.valpm7=0;
          }
          
      });

       this.listaProducionConsulta.sort((a, b) => (a.porcentaje < b.porcentaje) ? 1 : -1)
        this.lgModal.show();

       
     },
     err =>  this.alertService.danger('Error no hay  conexion..')
     );
  }


  validarNumeros(numero){
    if (!numero){
      return 0;
    }else{
      return numero;
    }
  }

  onChangePeriodo(valor) {
   this.periodo=valor;
  }
  
 
  onAm1(valor: number) {
    // this.periodo();
   }

   changeFiltrar(newValue) {
    this.searchText= newValue;
    this.searchItems();
  } 

  onKeypressFiltrar(value:string){
    this.searchText1=value;
    this.searchItemsBuscar();
   }

  grabar(){

    this.apiHoja.guardarLocales(this.listaProducion,this.parametro).subscribe((
      data) => {
        
        this.alertService.info("Se guardo con exito...")
        this.buscarProduccionesDevolucion();
        
    },
    err => 
    this.alertService.close(err)
    )}
  


  habilitarDias(){
      if (this.dias!=null){
       if (this.dias[0].dia_actual=="1"){ //Lunes
        this.parametro="LUNES";
         this.lunes=false;
         this.martes=false;
         this.domingo=true;
         this.collunes=false;
         this.devlunes=false;
         this.amlunes=false;
         this.amdomingo=true;
         this.coldomingo=true;
         this.colmartes=false;
         this.ammartes=false;
         this.devmartes=true;
         this.miercoles=true;
         this.jueves=true;
         this.viernes=true;
         this.sabado=true;
         this.devdomingo=false;
         this.devdomingoLunes=false;
         this.ampmdomingoLunes=true;
         this.lunescolor="yellow";  
         this.buscarProduccionesPorLocalParametroDomingo();
         }
       if (this.dias[0].dia_actual=="2" && this.dias[0].dia_anterior=="1"){ //Martes
        this.lunes=false;
        this.devdomingoLunes=true;
        this.martes=false;
        this.colmartes=false;
        this.amlunes=true;
        this.collunes=true;
        this.colmiercoles=false;
        this.devlunes=false;
        this.miercoles=false;
        this.ammiercoles=false;
        this.devmiercoles=true;
        this.jueves=true;
        this.viernes=true;
        this.sabado=true;
        this.domingo=true;
        this.ampmdomingoLunes=true;
        this.martescolor="yellow";  
      }
      if (this.dias[0].dia_actual=="3" && this.dias[0].dia_anterior=="2"){ //Miercoles
        this.lunes=true;
        this.devdomingoLunes=true;
        this.martes=false;
        this.miercoles=false;
      
        this.jueves=false;
        this.colmartes=true;
        this.devmartes=false;
        this.devmiercoles=false;
        this.amjueves=false;
        this.coljueves=false;
        this.devjueves=true;
        this.viernes=true;
        this.sabado=true;
        this.domingo=true;
        this.ampmdomingoLunes=true;
        this.miercolescolor="yellow";  
      }
      if (this.dias[0].dia_actual=="4" && this.dias[0].dia_anterior=="3"){ //Jueves
        this.lunes=true;
        this.martes=true;
        this.devdomingoLunes=true;
        this.miercoles=false;
        this.jueves=false;
        this.viernes=false;
        this.colmiercoles=true;
        this.ammiercoles=true;
        this.devmiercoles=false;
        this.devjueves=false;
        this.amjueves=false;
        this.amviernes=false;
        this.colvienes=false;
        this.devviernes=true;
        this.sabado=true;
        this.domingo=true;
        this.ampmdomingoLunes=true;
        this.juevescolor="yellow";  
      }
      if (this.dias[0].dia_actual=="5" && this.dias[0].dia_anterior=="4"){ //Viernes
        this.lunes=true;
        this.devdomingoLunes=true;
        this.martes=true;
        this.miercoles=true;
        this.jueves=false;
        this.viernes=false;
        this.sabado=false;
        this.coljueves=true;
        this.devjueves=false;
        this.amjueves=true;
        this.devviernes=false;
        this.amviernes=false;
        this.amsabado=false;
        this.colsabado=false;
        this.devsabado=true;
        this.domingo=true;
        this.ampmdomingoLunes=true;
        this.viernescolor="yellow";  
      }
      if (this.dias[0].dia_actual=="6" && this.dias[0].dia_anterior=="5"){ //Sabado
        this.lunes=true;
        this.devdomingoLunes=true;
        this.martes=true;
        this.miercoles=true;
        this.jueves=true;
        this.viernes=false;
        this.sabado=false;
        this.domingo=false;
        this.amviernes=true;
        this.colvienes=true;
        this.devviernes=false;
        this.devdomingo=true;
        this.ampmdomingoLunes=true;
        this.sabadocolor="yellow";  

      }


    //  [matKeyboard]="'Azərbaycanca'" darkTheme="true"
      if (this.dias[0].dia_actual=="7" && this.dias[0].dia_anterior=="6"){ //Domingo
        this.lunes=true;
        this.devdomingoLunes=true;
        this.martes=true;
        this.miercoles=true;
        this.jueves=true;
        this.viernes=true;
        this.sabado=false;
        this.domingo=false;
        this.amsabado=true;
        this.colsabado=true;
        this.devsabado=false;
        this.domingocolor="yellow"; 
        this.parametro="DOMINGO";
        this.ampmdomingoLunes=false;
        this.buscarProduccionesPorLocalParametroLunes(); 
      }
      }
      console.log("Holaaa-->"+this.colmiercoles);
      console.log("Holaaa-->"+this.ammiercoles);
      console.log("Holaaa-->"+this.devmiercoles);
      this.buscarProduccionesDevolucion();

  }

  buscarDias(){
    this.apiHoja.obtenerDias()
    .subscribe((
      data: DiasModule) => {
       console.log(data)
      this.dias = data;
      this.habilitarDias();
    },
    err =>  this.alertService.danger('Error no hay  conexion..')
    );

  }



  fieldsChangeCategoria(ev):void {

   if (ev.currentTarget.checked){
    this.searchText=ev.target.defaultValue;
    this.searchItems();
  
   }else{
    this.searchText="";
    this.searchItems(); 
   }
    
  }

  @HostListener('input') oninput() {
    this.searchItems();
  }
  
  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.listaProducion = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.listaProducion = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }


  searchItemsBuscar() {
    const prev = this.tableElBus.getDataSource();

    if (!this.searchText1) {
      this.tableElBus.setDataSource(this.previous);
      this.listaProducionConsulta = this.tableElBus.getDataSource();
    }

    if (this.searchText1) {
      this.listaProducionConsulta = this.tableElBus.searchLocalDataBy(this.searchText1);
      this.tableElBus.setDataSource(prev);
    }
  }
  
  buscarProduccionesPorLocal()
  {

   this.apiHoja.listarProduccionPorLocal(localStorage.getItem("local"),this.id_pais)
     .subscribe((
       data: HojaModule[]) => {
        
        console.log(data)
       this.listaProducion = data;
      this.listaProducion.forEach(element => {
        
        //Lunes
        if (element.dev1 == 0 ){
          element.dev1=undefined;
        }
          if (element.amval1 == 0 ){
            element.amval1=undefined;
          }
          
          if (element.valpm1 == 0 ){
            element.valpm1=undefined;
          }


           //Martes
        if (element.dev2 == 0 ){
          element.dev2=undefined;
        }
          if (element.valam2 == 0 ){
            element.valam2=undefined;
          }
          
          if (element.valpm2 == 0 ){
            element.valpm2=undefined;
          }

            //Miercoles
        if (element.dev3 == 0 ){
          element.dev3=undefined;
        }
          if (element.amval3 == 0 ){
            element.amval3=undefined;
          }
          
          if (element.valpm3 == 0 ){
            element.valpm3=undefined;
          }

              //Jueves
        if (element.dev4 == 0 ){
          element.dev4=undefined;
        }
          if (element.amval4 == 0 ){
            element.amval4=undefined;
          }
          
          if (element.valpm4 == 0 ){
            element.valpm4=undefined;
          }

              //Viernes
        if (element.dev5 == 0 ){
          element.dev5=undefined;
        }
          if (element.amval5 == 0 ){
            element.amval5=undefined;
          }
          
          if (element.valpm5 == 0 ){
            element.valpm5=undefined;
          }

               //Sabado
        if (element.dev6 == 0 ){
          element.dev6=undefined;
        }
          if (element.amval6 == 0 ){
            element.amval6=undefined;
          }
          
          if (element.valpm6 == 0 ){
            element.valpm6=undefined;
          }


            //Domingo
        if (element.dev7 == 0 ){
          element.dev7=undefined;
        }
          if (element.amval7 == 0 ){
            element.amval7=undefined;
          }
          
          if (element.valpm7 == 0 ){
            element.valpm7=undefined;
          }
          
      });
      this.listaCategorias = this.listaProducion.filter(
        (thing, i, arr) => arr.findIndex(t => t.categoria === thing.categoria) === i
      );
        
       this.mdbTable.setDataSource(this.listaProducion);
       this.mdbTable.stickyHeader
       this.mdbTable.dataSourceChange();
       this.previous = this.mdbTable.getDataSource();

     this.buscarProduccionesDevolucion();
     },
     err =>  this.alertService.danger('Error no hay  conexion..')
     );
 
  }


  buscarProduccionesDevolucion()
  {


         
       this.listaProducionDevolucion = this.listaProducion;
      this.listaProducionDevolucion.forEach(element => {
        
        if (this.dias!=null){
          if (this.dias[0].dia_actual=="1"){ //Domingo
           this.dia="DOMINGO";
            element.devolucionAnterior=element.dev8;
          }
          if (this.dias[0].dia_actual=="2"){ //Lunes
            this.dia="LUNES";
            element.devolucionAnterior=element.dev1;
          }
          if (this.dias[0].dia_actual=="3"){ //martes
            this.dia="MARTES";
            element.devolucionAnterior=element.dev2;
          }
          if (this.dias[0].dia_actual=="4"){ //miercoles
            this.dia="MIERCOLES";
            element.devolucionAnterior=element.dev3;
          }
          if (this.dias[0].dia_actual=="5"){ //jueves
            this.dia="JUEVES";
            element.devolucionAnterior=element.dev4;
          }

          if (this.dias[0].dia_actual=="6"){ //viernes
            this.dia="VIERNES";
            element.devolucionAnterior=element.dev5;
          }
          if (this.dias[0].dia_actual=="7"){ //sabado
            this.dia="SABADO";
            element.devolucionAnterior=element.dev6;
          }
          
        }
      }
      );



      this.mdbTableDev.setDataSource(this.listaProducionDevolucion);
      this.mdbTableDev.dataSourceChange();
    
    
     
    
  }

  buscarPeriodos()
  {

   this.apiHoja.listarPeriodoLocal(this.id_pais)
     .subscribe((
       data: PeriodoModule[]) => {
         this.listaPeriodo = data;
     
     },
     err =>  this.alertService.danger('Error no hay  conexion..')
     );
 
  }


  buscarProduccionesPorLocalParametroDomingo()
  {
   this.apiHoja.listarProduccionPorLocalParametro(localStorage.getItem("local"),"DOMINGO",localStorage.getItem("id_pais"))
     .subscribe((
       data: HojaModule[]) => {
         
        console.log(data)
       this.listaProducionLunes = data;
      this.listaProducion.forEach(element => {
        this.listaProducionLunes.forEach(lunes => {
          if (lunes.codigo==element.codigo){
            element.dev8=lunes.dev7
          }


          
        });

          
      });
       this.mdbTable.setDataSource(this.listaProducion);
       this.mdbTable.stickyHeader
       this.mdbTable.dataSourceChange();
       this.previous = this.mdbTable.getDataSource();
       this.buscarProduccionesDevolucion();
     },
     err =>  this.alertService.danger('Error no hay  conexion..')
     );
 
  }

  buscarProduccionesPorLocalParametroLunes()
  {
   this.apiHoja.listarProduccionPorLocalParametro(localStorage.getItem("local"),"LUNES",localStorage.getItem("id_pais"))
     .subscribe((
       data: HojaModule[]) => {
         
        console.log(data)
       this.listaProducionLunes = data;
      this.listaProducion.forEach(element => {
        this.listaProducionLunes.forEach(lunes => {
          if (lunes.codigo==element.codigo){
            element.amval8=lunes.amval1;
            element.valpm8=lunes.valpm1;
          }


          
        });

          
      });
       this.mdbTable.setDataSource(this.listaProducion);
       this.mdbTable.stickyHeader
       this.mdbTable.dataSourceChange();
       this.previous = this.mdbTable.getDataSource();
     },
     err =>  this.alertService.danger('Error no hay  conexion..')
     );
 
  }

}
function distinct(arg0: (x: any) => any): import("rxjs").OperatorFunction<{ Id: string; Name: string; }, unknown> {
  throw new Error('Function not implemented.');
}

